'use strict';

// Config HTTP Error Handling
angular.module('users').config(['$httpProvider',
	function($httpProvider) {
		// Set the httpProvider interceptor to define behaviour for 'Unauthorized' and 'Forbidden' responses
		// this will trigger on rejected api data requests
		$httpProvider.interceptors.push(['$q', '$location', 'Authentication',
			function($q, $location, Authentication) {
				return {
					responseError: function(rejection) {
						switch (rejection.status) {
							case 401:
								// Deauthenticate the global user
								Authentication.user = {};
								//redirect to home
								$location.path('/');
								break;
							case 403:
								// Add 'Forbidden' behaviour
								break;
						}
						return $q.reject(rejection);
					}
				};
			}
		]);
	}
]);
